import {Connection, PublicKey} from "@solana/web3.js";

const url = 'https://specific-lanny-fast-mainnet.helius-rpc.com/'
//
// const poolTokens = [
//     "mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So",
//     "bSo13r4TkiE4KumL71LsHTPpL2euBYLFx6h9HP3piy1",
//     "J1toso1uCk3RLmjorhTtrVwY9HJ7X8V9yYac6Y7kGCPn"
// ]

export async function getAssetsByOwner(key, filter = [] ) {
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            jsonrpc: '2.0',
            id: 'my-id',
            method: 'getAssetsByOwner',
            params: {
                ownerAddress: key,
                page: 1, // Starts at 1
                limit: 1000,
                displayOptions: {
                    showFungible: true //return both fungible and non-fungible tokens
                }
            },
        }),
    });
    const { result } = await response.json();
    if (filter.length) {
        return result.items.filter(item => filter.includes(item.id))
    } else return result.items

};

// get SOL balance
export async function getSolBalance(key) {
    const connection = new Connection(url);
    const balance = await connection.getBalance(new PublicKey(key));
    return balance;
}
